import {ChangeDetectionStrategy, Component, Inject, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Observable} from 'rxjs';
import {takeUntil, tap} from 'rxjs/operators';
import {AuthService} from '../../../components/auth/auth.service';
import {destroy$} from '../../../components/destroyable';
import {ModalService} from '../../../components/modal';
import {CONFIRM_COMMON_STRINGS} from '../../../components/modal/confirm-modal';
import {OverlayService} from '../../../components/overlay';
import {UserStatus} from '../../../enums/user-status';
import {ROUTE_REDIRECTS_TOKEN, RouteRedirects} from '../../../models/route-redirects';
import {UserService} from '../../../services/user.service';
import {ONBOARDING_STATUS_DICT, OnboardingStatusDictRecord} from '../display-onboarding-status';
import {OnboardingUser} from '../onboarding-user';

@Component({
    selector: 'onboarding-submit-confirm-modal',
    templateUrl: './onboarding-submit-confirm-modal.component.html',
    styleUrls: ['./onboarding-submit-confirm-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OnboardingSubmitConfirmModalComponent implements OnInit {

    public readonly UserStatus = UserStatus;

    public displayOnboardingStatus: OnboardingStatusDictRecord;

    public rejectReason: string;

    public readonly title: string = 'components.onboarding-page.submit_confirm_title';

    public readonly submitButtonText: string = CONFIRM_COMMON_STRINGS.buttonOk;

    public readonly destroy$ = destroy$();

    public isDashboardPage: boolean = false;

    private readonly dashboardUrl = this.routeRedirects.DASHBOARD_ROUTES[this.authService.userRole];

    constructor(
        private modalService: ModalService,
        private overlayService: OverlayService,
        private userService: UserService,
        private router: Router,
        private authService: AuthService,

        @Inject(ROUTE_REDIRECTS_TOKEN)
        private routeRedirects: RouteRedirects
    ) {}

    public ngOnInit(): void {
        this.setIsDashboard();
        this.createOverlay();
        this.listenToOnboardingStatus();
    }

    public close(): void {
        this.modalService.close(this);
    }

    public updateOnboardingStatus(user: OnboardingUser): void {
        this.displayOnboardingStatus = ONBOARDING_STATUS_DICT[user.status];

        this.rejectReason = user.status === UserStatus.REJECTED
            ? user.rejectReason
            : '';
    }

    private createOverlay(): void {
        this.overlayService.create({
            target: this.modalService.getByInstance(this)
        }).subscribe(() => this.close());
    }

    private listenToOnboardingStatus(): void {
        const user$ = this.userService.user$ as Observable<OnboardingUser>;

        user$.pipe(
            tap(user => {
                if (user) {
                    this.updateOnboardingStatus(user);
                } else {
                    this.close();
                }
            }),
            takeUntil(this.destroy$)
        ).subscribe();
    }

    private setIsDashboard(): void {
        this.isDashboardPage = this.dashboardUrl === this.router.url.split('?')[0]; // TODO: make better way
    }

}
